import { Plugin } from '@nuxt/types';
import { initializeI18n } from '../util/i18nInitializer';

const accessor: Plugin = ({ app }) => {
  initializeI18n(app.i18n);
};

export default accessor;
